<template>
  <div
    v-click-outside="() => { active = false; getNotifications(); }"
    class="notifications"
  >
    <div @click="showNotificationsList()">
      <transition name="fade">
        <div
          v-if="notificationsNumber > 0"
          class="notifications__alert notifications__alert--no-number"
        >
          <span class="notifications__number">
            {{ notificationsNumber | maxValue }}
          </span>
        </div>
      </transition>

      <dr-icon
        name="notification"
        color="#4a4a4a"
        class="notifications__icon"
      />
    </div>

    <transition-group name="fade_up">
      <div
        v-if="notification.length > 0"
        class="notifications__all"
        key="notifications-wrapper"
      >
        <transition-group name="fade_up">
          <div
            v-for="n in notification"
            :key="`notification-wrapper-item-${n.id}`"
            class="notifications__item"
          >
            <div class="notifications__item-body">
              <div class="notifications__item-img">
                <dr-vector
                  fill="gradient"
                  src="@/assets/img/Logo.svg"
                />
              </div>

              <div class="notifications__item-text">
                <h6 class="notifications__item-tit">
                  {{ n.title }}
                </h6>

                <p class="notifications__item-desc">
                  {{ n.msg }}
                </p>

              </div>
            </div>

            <div class="notifications__item-close">
              <i
                @click="markAsRead(n.id)"
                class="icon icon-cross"
              />
            </div>

            <div class="notifications__item-btn">
              <button
                @click="markAsRead(n.id)"
                class="btn btn-primary btn-sm"
              >
                OK
              </button>
            </div>
          </div>
        </transition-group>
      </div>
    </transition-group>

    <transition name="fade_up">
      <notifications-list
        class="notifications__list"
        :active.sync="active"
        :notifications-list="mainNotificationList"
        @read-notification="markAsRead"
      />
    </transition>
  </div>
</template>

<script>
import notificationsList from '@/components/modals/notificationsList'
import EventBus from '@/globals/eventBus'

export default {
  components: {
    notificationsList
  },

  filters: {
    maxValue (val) {
      const total = parseInt(val)
      if (total > 99) {
        return '99+'
      }
      return total
    }
  },

  data () {
    return {
      active: false,
      mainNotificationList: [],
      notification: [],
      seconds: 10000,
      timeout: Function
    }
  },

  computed: {
    prefix () {
      return this.fn_IS_DOCTOR()
        ? '/doctor'
        : `/secretary/doctor/${this.$route.params.doctorId}`
    },

    notificationsNumber () {
      return this.mainNotificationList.filter(item => !item['is_read']).length
    }
  },

  created () {
    // rota de notificações para secretary ainda não existe
    if (this.fn_IS_SECRETARY()) {
      return
    }

    this.getNotifications()

    EventBus.$on('new-notification', (payload) => this.showNotification(payload))
  },

  beforeDestroy () {
    clearInterval(this.timeout)
  },

  methods: {
    async getNotifications () {
      const url = `${this.prefix}/notification?order[n.createdAt]=desc`
      const { data } = await this.$http.get(url, this.$store.getters.getAuthHeader)
      this.mainNotificationList = [...data.data]
    },

    showNotification (notification) {
      this.active = false

      // Caso já exista uma notificação mostrada
      if (this.notification.length > 0) {
        // Remove a notificação
        this.notification.splice(0, 1)
        // Limpa o timeout
        clearTimeout(this.timeout)
        // Espera o efeito de transição CSS terminar, e então mostra a nova notificação
        setTimeout(() => this.notification.splice(0, 0, notification), 500)
      } else {
        this.notification.splice(0, 0, notification)
      }

      this.timeout = setTimeout(() => this.notification.splice(0, 1), this.seconds)
    },

    hideNotification (notification = 1) {
      this.notification.splice(0, notification)
    },

    markAsRead (id) {
      this.readNotifications([id])
      this.hideNotification()
      this.getNotifications()
    },

    readNotifications (ids = []) {
      if (ids.length > 0) {
        const url = `${this.prefix}/notifications/read`
        const method = 'put'
        const data = { notificationIds: ids }
        const headers = this.$store.getters.getAuthHeader.headers

        this.fn_SHOW_PROGRESS()
        this.$http({ method, url, data, headers })
          // .then((res) => console.log(res))
          .catch((err) => console.log(err))
          .finally(() => this.fn_HIDE_PROGRESS())
      }

      return false
    },

    showNotificationsList () {
      // Caso já exista uma notificação mostrada
      if (this.notification.length > 0) {
        this.markAsRead(this.notification[0].id)

        // Espera o efeito CSS completar para mostrar a lista
        setTimeout(() => (this.active = !this.active), 500)
      } else {
        // Caso a lista de notificações esteja ativa
        // clique no sino = marcar como lida as notificações não lidas
        if (this.active) {
          const ids = this.mainNotificationList.map(n => n.id)
          this.readNotifications(ids)
          this.getNotifications()
        }

        this.active = !this.active
      }
    }
  }
}
</script>
